import React from 'react';
import DocumentModal from './DocumentModal';
import DocumentItem from './DocumentItem';

class DocumentList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      documents: props.documents,
      deletedIds: [],
    };
  }

  componentWillUpdate(_, nextState) {
    if (
      nextState.deletedIds !== this.state.deletedIds ||
      nextState.documents !== this.state.documents
    ) {
      this.props.onChange();
    }
  }

  onOpenModal = () => this.setState({ isModalOpen: true });
  onCloseModal = () =>
    this.setState({
      isModalOpen: false,
      currentDocument: undefined,
    });

  getDeletedIds() {
    return this.state.deletedIds;
  }

  getDocuments() {
    return this.state.documents;
  }

  onDisplayDocument = document =>
    this.setState({
      isModalOpen: true,
      currentDocument: document,
    });

  onSaveDocument = document => {
    const addOrUpdate = documents => {
      const index = documents.findIndex(
        d => d.id.toString() === document.id.toString()
      );
      if (index > -1) {
        const copy = [...documents];
        copy[index] = document;
        return copy;
      } else {
        return [...documents, document];
      }
    };

    this.setState(state => ({
      documents: addOrUpdate(state.documents),
      isModalOpen: false,
      currentDocument: undefined,
    }));
  };

  onToggleDocumentDefault = document => {
    const value = !document.by_default;

    this.setState(state => ({
      documents: state.documents.map(d => {
        if (d.id.toString() === document.id.toString()) {
          return {
            ...d,
            by_default: value,
          };
        } else if (value && d.by_default) {
          return {
            ...d,
            by_default: false,
          };
        } else {
          return d;
        }
      }),
    }));
  };

  onRemoveDocument = (event, document) => {
    event.stopPropagation();
    event.preventDefault();

    this.setState(state => ({
      documents: state.documents.filter(
        d => d.id.toString() !== document.id.toString()
      ),
      deletedIds: document.isNew
        ? state.deletedIds
        : [...state.deletedIds, document.id.toString()],
    }));
  };

  render() {
    const { isModalOpen, currentDocument, documents } = this.state;

    return (
      <div>
        <table className="ui sortable table billLineList">
          <thead>
            <tr>
              <th className="one wide">
                <a className="ui icon button create" onClick={this.onOpenModal}>
                  <i className="icon add" />
                </a>
              </th>
              <th>Libellé</th>
              <th className="two wide">Modèle par défaut</th>
            </tr>
          </thead>
          <tbody>
            {documents.map(document => (
              <DocumentItem
                key={document.id}
                document={document}
                onToggleDefault={this.onToggleDocumentDefault}
                onDisplay={this.onDisplayDocument}
                onRemove={this.onRemoveDocument}
              />
            ))}
          </tbody>
        </table>
        {isModalOpen && (
          <DocumentModal
            current={currentDocument}
            onSave={this.onSaveDocument}
            onClose={this.onCloseModal}
          />
        )}
      </div>
    );
  }
}

export default DocumentList;



// WEBPACK FOOTER //
// ./src/modules/saas/settings/components/DocumentList.js